import { Link } from "react-router-dom";
import { LegalComercioFooter } from "../components/legal/LegalComercioFooter";

export function UnauthorizedPage() {
  return (
    <div className="flex min-h-screen flex-col bg-[#F5F7FA]">
      <div className="flex flex-1 flex-col items-center justify-center px-4">
        <h1 className="text-2xl font-semibold text-[#2C2C2C]">403</h1>
        <p className="mt-2 text-gray-600">No tienes permiso para acceder a esta página.</p>
        <Link to="/login" className="mt-6 font-medium text-[#1A3AB8] hover:underline">
          Volver al inicio de sesión
        </Link>
      </div>
      <LegalComercioFooter />
    </div>
  );
}
